var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topicName === 'orthographe')?_c('h3',{staticClass:"ortho-title"},[_vm._v("Les parcours d'"+_vm._s(_vm.topicName))]):_c('h3',{staticClass:"ortho-title"},[_vm._v("Les parcours de "+_vm._s(_vm.topicName))])}
var staticRenderFns = []

export { render, staticRenderFns }